import { render } from "./DebugEnv.vue?vue&type=template&id=b8d16016"
import script from "./DebugEnv.vue?vue&type=script&lang=js"
export * from "./DebugEnv.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zellwegv/repos-work/fw-312-bird-identification-game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__